import { render, staticRenderFns } from "./ItemBrandsListFilters.vue?vue&type=template&id=4adb2f9f"
import script from "./ItemBrandsListFilters.vue?vue&type=script&lang=js"
export * from "./ItemBrandsListFilters.vue?vue&type=script&lang=js"
import style0 from "./ItemBrandsListFilters.vue?vue&type=style&index=0&id=4adb2f9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports